<!-- 控销-商品管理 -->
<template>
    <div class="classification">
      <div class="header">
        <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left">
           
          <el-form-item>
            <el-button size="small" @click="download()"  type="primary">完税证明下载</el-button>
          </el-form-item>
  
        </el-form>
       
      </div>
   
    </div>
  </template>
  
  <script>
 
  import { mapGetters } from 'vuex'
 
  import {
    queryPayTaxeCertificate,
  } from "@/api/externalSalesRule";
 
  export default {
    components: {  },
    data() {
      return { 
        formTool: { 
        }, 
      };
    },
    computed: {},
    watch: {},
    created() {
      
    },
    mounted() { },
    beforeCreate() { },
    beforeMount() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    destroyed() { },
    activated() { },
    computed: {
      ...mapGetters(['permissions']),
    },
    methods: { 
      //完税证明下载
      download(current) { 
        queryPayTaxeCertificate({}).then((res) => { 
        });
      },
    },
  };
  </script>
  <style lang='scss' scoped>
  @import "@/styles/variables.scss";
  
  .classification {
    padding: 0px;
  
    .header {
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 24px 0px 24px !important;
      border-bottom: 1px solid #f5f5f5;
  
      .font {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        text-align: left;
        color: #262626;
      }
  
      .el-form-item {
        margin: 0px 0px 0px 8px !important;
      }
    }
  
    background: white;
  
    .top {
      display: flex;
      padding: 10px 0 10px 0;
  
      .item {
        display: flex;
        align-items: center;
        margin-right: 20px;
  
        .label {
          width: 120px;
        }
  
        .button {
          margin-right: 20px;
  
          ::v-deep .el-button {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
  
            &:hover {
              color: $subMenuActiveText;
              background-color: $butColor;
              border-color: $butColor;
            }
  
            &:active {
              color: $subMenuActiveText;
              background: $butColor;
              background-color: $butColor;
              border-color: $butColor;
            }
  
            &:focus {
              color: $subMenuActiveText;
              background-color: $butColor;
              border-color: $butColor;
            }
          }
        }
      }
    }
  
    .center {
      margin-top: 16px;
      padding: 0 24px;
      height: calc(100% - 131px);
  
      .shangjia {
        position: absolute;
        z-index: 2;
        bottom: -45px;
      }
    }
  
    .btn-warp {
      display: flex;
      justify-content: space-around;
  
      .el-link {
        // margin: 5px;
      }
    }
  }
  </style>
  